module.exports = __webpack_public_path__ + "icons/original/large/large-f4.43276b459501e836f1928103bcbdc92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f4.png
// module id = yFfv
// module chunks = app